import gql from 'graphql-tag';

export default gql`
  fragment FlightOrderItemFragment on OrderItem {
    ... on FlightOrderItem {
      id
      flight {
        id
        number
        providerId
        origin {
          code
          displayName
          city
          state
          country
          title
          street
          postalCode
        }
        destination {
          code
          displayName
          city
          state
          country
          title
          street
          postalCode
        }
        departingTime
        arrivalTime
        isOvernight
        operatedBy {
          carrier
        }
      }
      flightPrice: price {
        total
        subtotal
        taxesAndFees
        taxes {
          total {
            amount
            currency
          }
          breakdown {
            name
            code
            value {
              amount
              currency
            }
          }
        }
        fees {
          total {
            amount
            currency
          }
          breakdown {
            name
            code
            value {
              amount
              currency
            }
          }
        }
        discountValue {
          amount
          currency
        }
        discountType
        total
      }
      isBOGOApplied
    }
  }
`;
